import React from 'react';
import PageSection from '../../components/PageSection';
import DataTable from '../../components/DataTable';
import RawJsonDisplay from '../../components/RawJsonDisplay';
import { AccountInfo } from 'types';
import { useAPI } from '../../api';
import { OrgContextLink } from 'components/OrgContextProvider';

interface AccountsListContainerProps {
	accounts: AccountInfo[];
	onChanged: () => void;
}

const AccountsListContainer = ({ accounts, onChanged }: AccountsListContainerProps) => {
	const api = useAPI();

	const deleteAccount = (account: AccountInfo) => {
		if (window.confirm(`Delete account "${account.name}"? This will also delete all associated tenants and workspaces.`)) {
			api.delete(`/api/accounts/${account.id}`)
			.then(() => onChanged());
		}
	};

	return (
		<div>
			<PageSection title="Accounts" level={1}>
				<DataTable<AccountInfo>
					data={accounts}
					columns={[
						{ label: 'Name', key: 'name', render: (account) => <OrgContextLink to={`/settings/accounts/${account.id}`}>{account.name}</OrgContextLink> },
						{ label: 'ID', key: 'id' }
					]}
					tools={[
						{ label: 'Delete', action: (account) => deleteAccount(account) }
					]}
					tableTools={[
						{ label: 'Create New Account...', render: () => <OrgContextLink to="/settings/accounts/new">Create New Account...</OrgContextLink> }
					]}
				/>
			</PageSection>

			<PageSection title="Raw Data" level={2}>
				<RawJsonDisplay data={accounts} />
			</PageSection>
		</div>
	);
};

export default AccountsListContainer;
